import { render, staticRenderFns } from "./FormFilterInterconsultas.vue?vue&type=template&id=5ff8c4e4"
import script from "./FormFilterInterconsultas.vue?vue&type=script&lang=js"
export * from "./FormFilterInterconsultas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports